// Scrolls tab menus that are wider than the screen when the mouse rests near their left or right edge.
// Only on devices with a mouse; touch devices keep the normal swipe scrolling.

const EDGE_WIDTH = 30;
const SPEED = 8;

let activeMenu = null;
let direction = 0;
let frame = null;

function step() {
  if (!activeMenu || !direction) {
    frame = null;
    return;
  }

  const before = activeMenu.scrollLeft;
  activeMenu.scrollLeft = before + direction * SPEED;

  // Stop at the start or end of the menu
  if (activeMenu.scrollLeft === before) {
    direction = 0;
    frame = null;
    return;
  }

  frame = window.requestAnimationFrame(step);
}

function directionFor(menu, clientX) {
  if (menu.scrollWidth <= menu.clientWidth + 1) {
    return 0;
  }

  const rect = menu.getBoundingClientRect();
  const right = Math.min(rect.right, window.innerWidth);

  if (clientX - rect.left < EDGE_WIDTH && menu.scrollLeft > 0) {
    return -1;
  }
  if (right - clientX < EDGE_WIDTH && menu.scrollLeft + menu.clientWidth < menu.scrollWidth - 1) {
    return 1;
  }
  return 0;
}

function onMouseMove(event) {
  const menu = event.target && event.target.closest ? event.target.closest('.nav-tabs') : null;

  activeMenu = menu;
  direction = menu ? directionFor(menu, event.clientX) : 0;

  if (direction && !frame) {
    frame = window.requestAnimationFrame(step);
  }
}

export default function installTabEdgeScroll() {
  if (typeof window === 'undefined' || !window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  document.addEventListener('mousemove', onMouseMove, { passive: true });
  document.addEventListener('mouseleave', function() {
    direction = 0;
  });
}
